import React, {Component} from 'react';
import moment from 'moment';

class UpcomingAppointment extends Component {
    constructor(props) {
        super(props);
        this.templateAppointments = this.templateAppointments.bind(this);
        this.redirectEditAccount = this.redirectEditAccount.bind(this);
    }

    redirectEditAccount(e) {
        e.preventDefault();
        this.props.handleEditAccount()
    }

    viewAppointment(id) {
        this.props.handleAppointment(id);
    }

    templateAppointments(appointment) {
        let day = moment(appointment.start_date).format('dddd'),
            month = moment(appointment.start_date).format('MMMM Do'),
            time = moment(appointment.start_date).format('h:mm a');
        return (
            <p className="appointments-field" key={appointment.id}>
                <span className="date">
                    <span className="date-item date-day">{day}, </span>
                    <span className="date-item date-month">{month}, </span>
                    <span className="date-item date-time">{time}</span>
                </span>
                {
                    appointment.status == 'pending' ?
                        (
                            <span className="details">Pending</span>
                        ) : appointment.status == 'cancelled' ?
                        (
                            <span className="details">Cancelled</span>
                        ) :
                        (
                            <a
                                className="details details-view"
                                href="#"
                                onClick={this.viewAppointment.bind(this, appointment.id)}
                            ><span>View</span> <span>Details</span></a>
                        )
                }
            </p>
        )
    }

    render() {
        let appointments = this.props.appointments;
        let pastAppointments = this.props.pastAppointments;

        return (
            <div className="smart-forms smart-container wrap-2">
                <div className="form-section-upcoming">
                    <div className="form-header header-appointments">
                        <h4>Upcoming Appointments</h4>
                    </div>
                    <div className="upcoming-appointments">
                        {
                            appointments.map(this.templateAppointments)
                        }
                    </div>
                </div>
                <div className="form-section-upcoming">
                    <div className="form-header header-appointments">
                        <h4>Past Appointments</h4>
                    </div>
                    <div className="previous-appointments">
                        {
                            pastAppointments.map(this.templateAppointments)
                        }
                    </div>
                </div>
                <div className="form-body smart-steps steps-theme-primary">
                    <form id="smart-form">
                        <fieldset>
                            <div className="controls">
                                <div className="sendit">
                                    <button
                                        type="submit"
                                        className="button btn-primary"
                                        onClick={this.redirectEditAccount}
                                    > Edit Account
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        )
    }
}

export default UpcomingAppointment;


/** WEBPACK FOOTER **
 ** ./src/components/UpcomingAppointment.js
 **/